import React from 'react';
import { Container, Typography, Box, Grid, Collapse, CircularProgress } from '@mui/material';
import Banner from "../../components/Banner";
import BannerHub from './../../components/BannerHub.js';
import CarouselArticulos from './../../components/CarouselArticulos';
import { useState, useEffect } from 'react';
import AlternatingInfoBlock from "../../components/AlternatingInfoBlock";
import CallToActionSection from "./../../components/CallToActionSection.js";
import PurposeCirclesSection from "./../../components/PurposeCirclesSection.jsx";
import { fetchAllBlogPosts } from './../../components/wordpressUtils';



const opciones = [
  {
    label: "PROPIEDAD",
    contenido: (
      <span>Es el derecho legal que una persona o entidad tiene sobre un bien. Puede tratarse de objetos físicos o intangibles como patentes o marcas.
        <b> La propiedad suele implicar el control y disfrute exclusivo de los bienes.</b>
      </span>
    ),
  },
  {
    label: "PATRIMONIO",
    contenido: (
      <span>Es el <b>conjunto de bienes, derechos y obligaciones</b> que una persona o entidad posee en un momento dado. Incluye tanto activos como pasivos, es decir, no solo lo que se posee,  sino también las deudas o compromisos financieros.
      </span>
    ),
  },
  {
    label: "RIQUEZA",
    contenido: (
      <span>Se refiere a la <b>abundancia de bienes, recursos o activos</b> que una persona o entidad posee. Abarca no solo el patrimonio en un sentido financiero, sino también otros recursos valiosos como conocimientos, habilidades, y relaciones que contribuyen al bienestar general de un individuo o familia.
      </span>
    ),
  },
  {
    label: "LEGADO",
    contenido: (
      <span>
        Es lo que una persona deja tras su fallecimiento, ya sea en términos materiales (propiedades, patrimonio) o inmateriales (valores, conocimientos, cultura).
        <br /><br />
        A menudo, <b>el legado tiene una connotación más trascendental</b>, pues se relaciona con el impacto duradero que una persona deja en su comunidad, familia o sociedad.
        <br /><br />
        También puede incluir contribuciones sociales, intelectuales o emocionales.
      </span>
    ),
  },
];

export default function Propiedad() {
  const [activo, setActivo] = useState("PROPIEDAD");
  const activoIndex = opciones.findIndex((el) => el.label === activo);
   const [isLoadingArticles, setIsLoadingArticles] = useState(true);
    const [wordpressArticles, setWordpressArticles] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
        const fetchData = async () => {
          try {
            setIsLoadingArticles(true);
            const wpArticles = await fetchAllBlogPosts();
            setWordpressArticles(wpArticles);
          } catch (err) {
            console.error('Error al obtener artículos:', err);
          } finally {
            setIsLoadingArticles(false);
          }
        };
        
        fetchData();
      }, []);
  

  return (
    <Container sx={{ margin: '0', padding: '0 !important', maxWidth: '100vw !important' }}>
      <Banner
        titleBackgroundColor="#3B7F79"
        backgroundImage="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745597006/ebm/banner-propiedad_g3uo3j.png"
        extraContent={
          <Box
            sx={{
              bottom: 0,
              left: 0,
              maxWidth: { xs: '350px', sm: '500px', md: '600px' },
              padding: "10px",
              paddingLeft: { xs: '2.2rem', sm: '7.2rem' },
              textAlign: "justify",
              placeContent: 'inherit'
            }}
          >
            <Typography sx={{ color: 'white', fontSize: { xs: '14px', sm: '16px' }, textAlign: 'left', textShadow: '0px 2px 10px rgb(0,0,0,0.5)', letterSpacing: 2 }}>EJES DE ACCIÓN</Typography>
          </Box>
        }
        title="La propiedad"
        subtitle={
          <Box sx={{
            padding: { xs: "2rem 2rem", sm: "2.2rem 7.2rem" },
            textAlign: { sm: "justify" },
            width: '100%', marginBottom: '14vh'
          }}>
            <Typography sx={{ fontSize: { xs: '12px', sm: '14px', md: '16px' }, textShadow: '0px 2px 10px rgb(0,0,0,0.5)', maxWidth: { sm: '450px', md: '600px' } }}>
              Nos enfocamos en <strong>preservar tu patrimonio</strong> a lo largo de las generaciones mediante estrategias que fomentan su crecimiento.</Typography>
          </Box>
        }
        variant="bottom-left"
      />

      <Box
        sx={{
          backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1745605799/ebm/fondo-propiedad_n8w68u.png)',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          // Key change: Make the background fixed relative to the viewport
          backgroundAttachment: 'fixed',
          width: '100%',
          overflow: 'hidden',
          py: 8,
          // Keep minHeight to help with overall layout, but fixed attachment is primary for static background
          minHeight: { xs: '800px', md: '700px', lg: '600px' }
        }}
      >
        <Grid container sx={{ alignItems: 'center' }}>
          <Grid
            item
            xs={12}
            md={8}
            lg={5.5}
            sx={{
              fontWeight: 'bold',
              borderRadius: '0rem 100px 20px 0rem',
              p: 8,
              pl: { xs: 8, sm: 13 },
              background: 'linear-gradient(25deg,rgba(0,0,0, 0.2) 10%,rgba(0,0,0, 0.3))',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: { xs: 'center', lg: 'flex-end' },
              boxShadow: '0px 2px 10px rgba(0,0,0,0.4)',
              transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
              border: 'none',
              zIndex: 1,
              backdropFilter: 'blur(10px)',
              m: { xs: 2, lg: 0 },
              ml: { xs: 0, lg: 0 }
            }}
          >
            <Box sx={{ borderLeft: "1px solid #3B7F79" }}>
              <Typography sx={{ fontSize: { xs: '28px', lg: '38px' }, color: '#D4A76A', pb: 4, pl: 4, fontWeight: '900', lineHeight: 1 }}>
                CONCEPTOS CLAVE
              </Typography>
              <Typography
                sx={{
                  color: 'white',
                  maxWidth: { xs: '100%', lg: '600px' },
                  textAlign: 'justify',
                  fontSize: '16px',
                  pl: 4,
                }}
              >
                En EBM, sabemos que ser propietario de activos significa más que simplemente poseer bienes: implica tomar decisiones clave para preservar y hacer crecer tu patrimonio. <br></br><br></br>
                Nuestro enfoque "La Propiedad" está diseñada para ayudarte a gestionar de manera estratégica y efectiva tu riqueza, asegurando su sostenibilidad y crecimiento a lo largo del tiempo. <br></br><br></br>
                Te apoyamos a maximizar el valor de tus activos y a garantizar un legado solido para las generaciones futuras con estrategias personalizadas y un enfoque integral.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} lg={6.5} sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            overflow: 'hidden',
          }}>
            <Grid container
              spacing={2}
              direction="column"
              sx={{
                maxWidth: '600px',
                pl: { xs: 2, md: 0 },
                position: 'relative',
              }}
            >
              {opciones.map((op, index) => {
                const isActive = activo === op.label;
                const distancia = Math.abs(index - activoIndex);

                return (
                  <Grid item key={op.label} sx={{
                    position: 'relative',
                    width: '100%',
                  }}>
                    <Box
                      onClick={() => setActivo(op.label)}
                      sx={{
                        cursor: "pointer",
                        borderRadius: "50rem 0rem 0rem 50rem",
                        px: 3,
                        py: 1,
                        backdropFilter: "blur(10px)",
                        transition: "all 0.3s ease",
                        background: isActive
                          ? "linear-gradient(25deg, #0A6274 10%, #13B8DA)"
                          : "rgba(255,255,255,0.05)",
                        color: isActive ? "white" : "rgba(255,255,255,0.5)",
                        fontWeight: isActive ? 700 : 100,
                        boxShadow: '0px 2px 10px rgba(0,0,0,0.4), -1px -1px 2px rgba(255,255,255,0.2)',
                        transform: isActive ? 'translateX(0)' : `translateX(${distancia * 10}px)`,
                        fontSize: '22px',
                        letterSpacing: 2,
                        width: '100%',
                        '&::before': {
                          content: '""',
                          position: 'absolute',
                          inset: 0,
                          padding: '1px',
                          borderRadius: '50rem 0rem 0rem 50rem',
                          background: isActive
                            ? "linear-gradient(180deg, #0ff, #0A6274)"
                            : "rgba(255,255,255,0)",
                          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                          WebkitMaskComposite: 'xor',
                          maskComposite: 'exclude',
                          zIndex: -1,
                        }
                      }}
                    >
                      {op.label}
                    </Box>

                    <Collapse in={isActive} timeout={500}>
                      <Box
                        sx={{
                          mt: 1,
                          maxWidth: '456px',
                         
                          px: 4,
                          py: 6,
                          backdropFilter: "blur(12px)",
                          backgroundColor: "linear-gradient(to right,rgb(0, 0, 0.0.2),rgb(0, 0, 0,0.3))",
                          color: "white",
                          transition: "all 0.3s ease",
                          boxShadow: '0px 2px 10px rgba(0,0,0,0.4)',
                          textAlign: 'justify',
                          position: 'relative',
                          '&::before': {
                            borderRadius: "12px",
                            content: '""',
                            position: 'absolute',
                            inset: 0,
                            padding: '1px',
                            background: 'linear-gradient(90deg, #666666,rgba(0, 0, 0, 1))',
                            WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                            WebkitMaskComposite: 'xor',
                            maskComposite: 'exclude',
                            zIndex: -1,
                          },
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: "16px",
                            "& strong": { fontWeight: 700 },
                          }}
                        >
                          {op.contenido}
                        </Typography>
                      </Box>
                    </Collapse>

                   
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>

        <Box sx={{ color: 'white', display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-start' }, px: 4, maxWidth: '1300px', mx: 'auto' }}>
          <Typography sx={{ fontSize: { xs: '20px', sm: '28px' }, pl: { xs: 0, md: 2 }, pt: 4 }}>Propósitos</Typography>
          <Typography
            sx={{
              fontSize: { xs: '20px', sm: '28px' },
              mb: 4,
              position: 'relative',
              px: 2,
              borderRadius: '50rem',
              background: 'linear-gradient(0deg, rgb(59,127,121,1), rgba(54, 176, 176, 0.20))',
              display: 'inline-block',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              boxShadow: '0px 2px 10px rgba(0,0,0,0.5)',
              transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
              zIndex: 1,
              '&::before': {
                content: '""',
                position: 'absolute',
                inset: 0,
                padding: '1px',
                borderRadius: '50rem',
                background: 'linear-gradient(180deg, rgb(59,127,121,1), rgba(54, 176, 176, 0.20))',
                WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                WebkitMaskComposite: 'xor',
                maskComposite: 'exclude',
                zIndex: -1,
              },
            }}
          >
            de la{" "}<Box component="span" sx={{ fontWeight: 700 }}>riqueza</Box>
          </Typography>
          <Typography sx={{ maxWidth: '550px', textAlign: 'justify' }}>La riqueza va más allá de acumular bienes; es una herramienta para construir un futuro pleno. Descubre cómo cada propósito de la riqueza contribuye a una vida equilibrada y significativa.</Typography>
        </Box>

        <PurposeCirclesSection />
      </Box>

      <CallToActionSection
        gradient="linear-gradient(to right, #2f2f2f, #1a1a1a)"
        title="Asegura el futuro de las próximas generaciones"
        description={`Descubre cómo <strong>asegurar el crecimiento y estabilidad de tu familia</strong> con nuestro enfoque integral en gestión y preservación del patrimonio. <strong> ¡Contáctanos y construye un legado duradero!</strong>`}
        buttonText="Agenda una cita"
        buttonLink="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2eVA-xB-1w0bULc68zTMQ5dWAK4AP9Ow9P6r6QQl4DFZkqdrRENaPyWxRyLbAtrmocL908Fkfl"
        image={'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745430078/ebm/propiedad-callToAction_ytepyr.png'}
      />

      <Box sx={{ pt: 10 }}>
        <Typography sx={{ color: '#3B7F79', textAlign: 'center', fontSize: '32px' }}>Nuestros <b>servicios</b></Typography>
        <Typography sx={{ letterSpacing: 1, textAlign: 'center', fontSize: '20px', textTransform: 'uppercase' }}>Asegura el futuro de tu patrimonio hoy</Typography>

        <AlternatingInfoBlock
          titleColor='#3B7F79'
          title="Plan de sucesión patrimonial"
          subtitle="CLAVE PARA LA CONTINUIDAD"
          description={
            <>
              Garantiza una transición armoniosa de la propiedad, protegiendo a la familia y asegurando la continuidad del negocio. Nuestro enfoque integral fomenta en los sucesores el desarrollo de un rol responsable como propietarios, capacitados para alinear recursos y esfuerzos hacia la creación de valor sostenible. <br />
              <br />
              Además, estructuramos la transferencia del patrimonio de manera eficiente y segura, salvaguardando la estabilidad del legado familiar para las futuras generaciones utilizando herramientas como testamentos, fideicomisos y donaciones.
            </>
          }

          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745436287/ebm/propiedad-img-1_kgzkmn.png"
        />

        <AlternatingInfoBlock
          titleColor='#3B7F79'
          title="Departamento patrimonial"
          subtitle="Protección, crecimiento y continuidad del patrimonio"
          description={
            <>
              Garantizar la adecuada gestión, protección y crecimiento del patrimonio familiar, separando los riesgos empresariales de los activos personales mediante estructuras legales y financieras especializadas. <br />
              <br />
              Anticipa las necesidades futuras de la familia, diseñando carteras de inversión alineadas con los objetivos a corto y largo plazo. Además, ofrece asesoría personalizada y establece planes para asegurar la continuidad del patrimonio, formando a las nuevas generaciones en su gestión.
            </>
          }

          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745436287/ebm/propiedad-img-2_dsd0kw.png"
          reverse
        />

        <AlternatingInfoBlock
          titleColor='#3B7F79'
          title="Valuación de negocios"
          subtitle="CUANTIFICA EL VALOR DE TU EMPRESA"
          description={
            <>
              Conoce exactamente cuánto vale tu negocio. Aplicamos metodologías financieras rigurosas para determinar el Valor Razonable de tu empresa o activos intangibles, brindándote certeza matemática para afrontar sucesiones patrimoniales, negociaciones de compraventa, levantamiento de capital o reestructuras corporativas.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783354349/ebm/propiedad-img-3_vvxfg1.png"
        />

        <AlternatingInfoBlock
          titleColor='#3B7F79'
          title="Valuación de activos"
          subtitle="CONOCER EL VALOR REAL DE TUS ACTIVOS"
          description={
            <>
              Determina el valor justo, de mercado o de liquidación de tus activos tangibles (inmuebles, maquinaria, inventario) o intangibles (marcas, patentes, software) mediante metodologías normadas. Obtén un dictamen oficial que te brinde certeza jurídica y financiera para respaldar decisiones en compraventas, garantías crediticias o reestructuras.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783354349/ebm/propiedad-img-4_sq2pgv.png"
          reverse
        />
      </Box>

      {/* Carrusel con artículos de WordPress */}
           <Box sx={{
             backgroundColor: 'white',
             pb: 10,
             pt: 8,
             display: 'flex',
             justifyContent: 'center',
             flexDirection: 'column',
             alignItems: 'center',
             borderBottom: '1px solid #E0E0E0'
           }}>
             <Typography sx={{
               py: 4,
               color: '#0A6274',
               fontSize: { xs: '1.6rem', md: '2rem' },
               fontWeight: 600,
               textAlign: 'center'
             }}>
               Explora nuestros <b>últimos insights</b>
             </Typography>
     
             {isLoadingArticles ? (
               <Box sx={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                 <CircularProgress color="primary" />
               </Box>
             ) : wordpressArticles.length > 0 ? (
               <CarouselArticulos wpData={wordpressArticles} />
             ) : (
               <Typography>No hay artículos disponibles</Typography>
             )}
        <BannerHub />
      </Box>
    </Container>
  );
}